import request from '../request'

/**
 * 项目要求确认及会签评审相关接口
 * 这里是从 cosystem-portal 同步过来的别名入口，
 * 实际方法定义在 @/api/project/review.js。
 */

export {
    fetchDetail,
    resubmitPrjReview,
    getPersonnel,
    getCompanyPersonnel
} from '../project/review'
